import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Label,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

const EditOutwardModal = ({
  isOpen,
  toggle,
  onSubmit,
  deliveryBoyList = [],
  editRowData = null,
  maxAllowedForEdit = 0,
  initialValues = {},
  t = (v) => v,
  submitLabel = "Update",
  cancelLabel = "Cancel",
  title = "Edit Outward",
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{t(title)}</ModalHeader>
      <ModalBody>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            noOfPieces: Yup.number()
              .required("Required")
              .min(1, "Must be at least 1")
              .test(
                "max-edit-pieces",
                `You can only edit up to ${maxAllowedForEdit} pieces.`,
                function (value) {
                  return value <= maxAllowedForEdit;
                }
              ),
            totalWeight: Yup.number().required("Weight is Required"),
            deliveryBoyName: Yup.string().required("Delivery Boy is Required"),
          })}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, values, handleChange }) => (
            <Form onSubmit={handleSubmit}>
              {/* Pieces */}
              <div className="mb-3 d-flex align-items-center">
                <Label
                  htmlFor="noOfPieces"
                  style={{ minWidth: 180 }}
                  className="me-3"
                >
                  <h5 className="text-secondary fw-bold">
                    {t("Pieces")}
                  </h5>
                </Label>
                <div className="w-50">
                  <Field
                    type="number"
                    name="noOfPieces"
                    className="form-control"
                    placeholder="Pieces"
                    value={values.noOfPieces}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="noOfPieces"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>
              </div>

              {/* Total Weight */}
              <div className="mb-3 d-flex align-items-center">
                <Label
                  htmlFor="totalWeight"
                  style={{ minWidth: 180 }}
                  className="me-3"
                >
                  <h5 className="text-secondary fw-bold">
                    {t("Total Weight")}
                  </h5>
                </Label>
                <div className="w-50">
                  <Field
                    type="number"
                    name="totalWeight"
                    className="form-control"
                    placeholder="Total Weight"
                    value={values.totalWeight}
                    onChange={handleChange}
                  />
                  <ErrorMessage
                    name="totalWeight"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>
              </div>

              {/* Remark */}
              <div className="mb-3 d-flex align-items-center">
                <Label
                  htmlFor="remark"
                  style={{ minWidth: 180 }}
                  className="me-3"
                >
                  <h5 className="text-secondary fw-bold">
                    {t("Remark")}
                  </h5>
                </Label>
                <Field
                  type="text"
                  name="remark"
                  className="form-control w-50"
                  placeholder="Remark"
                  as="textarea"
                  rows="3"
                  value={values.remark}
                  onChange={handleChange}
                />
              </div>

              {/* Delivery Boy */}
              <div className="mb-3 d-flex align-items-center">
                <Label
                  htmlFor="deliveryBoyName"
                  style={{ minWidth: 180 }}
                  className="me-3"
                >
                  <h5 className="text-secondary fw-bold">
                    {t("Delivery Boy")}
                  </h5>
                </Label>
                <div className="w-50">
                  <Field
                    as="select"
                    name="deliveryBoyName"
                    className="form-control"
                    value={values.deliveryBoyName}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      {t("Select")}
                    </option>
                    {deliveryBoyList.map(boy => (
                      <option key={boy.id} value={boy.id}>
                        {boy.name}
                      </option>
                    ))}
                  </Field>
                  <ErrorMessage
                    name="deliveryBoyName"
                    component="div"
                    className="text-danger mt-1"
                  />
                </div>
              </div>

              {/* Footer Buttons */}
              <div className="modal-footer">
                <button className="btn btn-primary" type="submit">
                  {t(submitLabel)}
                </button>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggle}
                >
                  {t(cancelLabel)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditOutwardModal; 